import React from 'react';
import 'react-multi-carousel/lib/styles.css';
import { ASSET_URL } from '../../../../env/Configurations';
import './Image-Component-With-Title-And-Body.scss';
import Carousel from 'react-multi-carousel';

const ImageComponentWithTitleAndBodyPreview = (props) => {
  const { config } = props;
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
  };

  return (
    <div className='image-with-body'>
      {config?.slides?.length && (
        <div>
          <div className='preview-title'>{config?.titleH1 ? config?.titleH1 : 'H1 Title'}</div>
          <div className='preview-body'>
            <p className='preview-breaks'>{config?.body ? config?.body : 'Body'}</p>
          </div>
          <div className='image-with-body-box'>
            <Carousel responsive={responsive} autoPlay={true} infinite={true}>
              {config.slides.map((slide, key) => (
                <>
                  {slide?.isVideo && (
                    <div className={`${slide?.shadowOverlay ? 'shadowed-img' : ''}`} key={key}>
                      <div className='video-container-imc'>
                        <video
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'fill',
                            position: 'fixed',
                            top: 0,
                            left: 0,
                          }}
                          autoPlay
                          loop={slide?.loopPlayBack}
                          preload='auto'
                          src={slide?.videoURL}
                          muted
                        />
                        <span
                          className='title-label-imc'
                          style={slide.videoURL ? { color: 'white' } : { color: 'black' }}
                        >
                          {slide.titleH3 ? slide.titleH3 : 'H3 Title'}
                        </span>
                      </div>
                    </div>
                  )}
                  {!slide.isVideo && (
                    <div
                      className={`d-flex align-items-center justify-content-center h-100 image-without-background-image-container ${
                        slide?.shadowOverlay ? 'shadowed-img' : ''
                      }`}
                      key={key}
                      style={
                        slide?.imgURL
                          ? {
                              backgroundImage: 'url(' + ASSET_URL + slide.imgURL + ')',
                              backgroundSize: 'cover',
                            }
                          : {}
                      }
                    >
                      <div
                        className='slide-title'
                        style={slide.imgURL ? { color: 'white' } : { color: 'black' }}
                      >
                        {slide.titleH3 ? slide.titleH3 : 'H3 Title'}
                      </div>
                    </div>
                  )}
                </>
              ))}
            </Carousel>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageComponentWithTitleAndBodyPreview;
